// Utility functions for modals and app downloads

export const handleAppDownload = (type) => {
  window.open('https://bsbfortradeprime.com/check_browser.php', '_blank');
};

export const openDemoBookingModal = (demoType) => {
  const modal = document.getElementById('demo-booking-modal');
  if (!modal) return;
  
  const demoTypeText = demoType === 'polymer' ? 'Polymer Support' : 'Logistics Support';
  const demoTypeBadge = document.getElementById('demo-type-badge');
  const demoTypeBadgeText = document.getElementById('demo-type-badge-text');
  const demoTypeTextEl = document.getElementById('demo-type-text');
  
  if (demoTypeBadge) {
    demoTypeBadge.style.display = 'flex';
    if (demoTypeBadgeText) demoTypeBadgeText.textContent = demoTypeText;
  }
  if (demoTypeTextEl) demoTypeTextEl.textContent = demoTypeText;
  
  // Save scroll position so we can restore it when modal closes (stay where user was)
  const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  modal.dataset.scrollY = String(scrollY);
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
  // Show modal with flex for perfect centering
  modal.style.display = 'flex';
  modal.classList.add('show');
  document.body.classList.add('modal-open');
  document.documentElement.classList.add('modal-open');
  
  // Initialize Calendly widget after modal is visible
  const initCalendly = (attempt = 0) => {
    const calendlyUrl = 'https://calendly.com/it-bsbbrokersllp/30min';
    const container = document.getElementById('calendly-container');
    
    // Max 10 attempts
    if (attempt > 10) {
      console.error('❌ Failed to initialize Calendly after multiple attempts');
      return;
    }
    
    if (window.Calendly && container) {
      try {
        // Use initInlineWidget for inline embedding (prevents popup)
        window.Calendly.initInlineWidget({
          url: calendlyUrl,
          parentElement: container
        });
        console.log('✅ Calendly inline widget initialized from functions.js');
      } catch (error) {
        console.error('❌ Error initializing Calendly:', error);
        // Retry after a delay
        setTimeout(() => initCalendly(attempt + 1), 500);
      }
    } else if (container && !window.Calendly) {
      // If Calendly script not loaded yet, wait a bit and try again
      console.log(`⏳ Waiting for Calendly script to load... (attempt ${attempt + 1})`);
      setTimeout(() => initCalendly(attempt + 1), 500);
    } else if (!container) {
      // Container not found, wait a bit
      console.log(`⏳ Waiting for container element... (attempt ${attempt + 1})`);
      setTimeout(() => initCalendly(attempt + 1), 300);
    }
  };
  
  // Try to initialize after modal is fully visible - longer delay to ensure DOM is ready
  setTimeout(() => initCalendly(0), 800);
};

// Blur focused element so browser doesn't scroll it into view when modal closes
function preventFocusScroll() {
  const active = document.activeElement;
  if (active && active !== document.body && typeof active.blur === 'function') {
    active.blur();
  }
}

// Restore scroll so page stays where user was (not hero/top)
function restoreScroll(scrollPos) {
  const pos = typeof scrollPos === 'number' ? scrollPos : parseInt(scrollPos, 10) || 0;
  const scroll = () => { window.scrollTo(0, pos); };
  scroll();
  requestAnimationFrame(() => { scroll(); requestAnimationFrame(scroll); });
  setTimeout(scroll, 0);
  setTimeout(scroll, 50);
  setTimeout(scroll, 100);
  setTimeout(scroll, 200);
}

export const closeDemoBookingModal = () => {
  const modal = document.getElementById('demo-booking-modal');
  if (modal) {
    const scrollPos = modal.dataset.scrollY != null ? modal.dataset.scrollY : '0';
    modal.style.display = 'none';
    modal.classList.remove('show');
    document.body.classList.remove('modal-open');
    document.documentElement.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    preventFocusScroll();
    restoreScroll(scrollPos);
  }
};

export const openEliteBuyerModal = () => {
  const modal = document.getElementById('elite-buyer-modal');
  if (modal) {
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    modal.dataset.scrollY = String(scrollY);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    // Use flex for perfect centering
    modal.style.display = 'flex';
    // Explicitly set background to ensure it shows
    modal.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
    modal.style.background = 'rgba(0, 0, 0, 0.6)';
    modal.classList.add('show');
    document.body.classList.add('modal-open');
    document.documentElement.classList.add('modal-open');
  }
};

export const closeEliteBuyerModal = () => {
  const modal = document.getElementById('elite-buyer-modal');
  if (modal) {
    const scrollPos = modal.dataset.scrollY != null ? modal.dataset.scrollY : '0';
    modal.style.display = 'none';
    modal.classList.remove('show');
    modal.style.backgroundColor = '';
    modal.style.background = '';
    document.body.classList.remove('modal-open');
    document.documentElement.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    preventFocusScroll();
    restoreScroll(scrollPos);
  }
};

export const openServiceInterestModal = (serviceName) => {
  const modal = document.getElementById('service-interest-modal');
  if (modal) {
    // Store the preselected service name in data attribute for React to pick up
    if (serviceName) {
      modal.dataset.preselectedService = serviceName;
    }
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    modal.dataset.scrollY = String(scrollY);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    // Set background IMMEDIATELY before showing modal
    modal.style.setProperty('background-color', 'rgba(0, 0, 0, 0.6)', 'important');
    modal.style.setProperty('background', 'rgba(0, 0, 0, 0.6)', 'important');
    
    // Add show class and display
    modal.classList.add('show');
    modal.style.display = 'flex';
    
    // Explicitly set background with important flag - multiple times to ensure it sticks
    const setBackground = () => {
      if (modal) {
        modal.style.setProperty('background-color', 'rgba(0, 0, 0, 0.6)', 'important');
        modal.style.setProperty('background', 'rgba(0, 0, 0, 0.6)', 'important');
      }
    };
    
    // Set background multiple times to ensure it persists
    setBackground();
    requestAnimationFrame(() => {
      setBackground();
      setTimeout(setBackground, 0);
      setTimeout(setBackground, 10);
      setTimeout(setBackground, 50);
      setTimeout(setBackground, 100);
    });
    
    document.body.classList.add('modal-open');
    document.documentElement.classList.add('modal-open');
    
    // Use MutationObserver to ensure background stays set
    const observer = new MutationObserver(() => {
      if (modal && modal.style.display !== 'none') {
        setBackground();
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });
    
    // Store observer to disconnect later
    modal._backgroundObserver = observer;
  }
};

export const closeServiceInterestModal = () => {
  const modal = document.getElementById('service-interest-modal');
  if (modal) {
    if (modal._backgroundObserver) {
      modal._backgroundObserver.disconnect();
      delete modal._backgroundObserver;
    }
    const scrollPos = modal.dataset.scrollY != null ? modal.dataset.scrollY : '0';
    modal.classList.remove('show');
    modal.style.display = 'none';
    modal.style.backgroundColor = '';
    modal.style.background = '';
    document.body.classList.remove('modal-open');
    document.documentElement.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    preventFocusScroll();
    restoreScroll(scrollPos);
  }
};

export const openEventModal = (eventType) => {
  const modal = document.getElementById('event-modal');
  if (modal) {
    const eventTypeInput = document.getElementById('event-type');
    const modalTitle = document.getElementById('modal-title');
    
    if (eventTypeInput) eventTypeInput.value = eventType;
    if (modalTitle) {
      const titles = {
        'synergy-meet': 'Synergy Meet West Zone Registration',
        'elite-buyer': 'Elite Buyer Club Registration',
        'channel-partner': 'Channel Partner Meet Registration',
        'supplier-meet': 'Supplier Meet Registration'
      };
      modalTitle.textContent = titles[eventType] || 'Event Registration';
    }
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    modal.dataset.scrollY = String(scrollY);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    // Set background IMMEDIATELY before showing modal
    modal.style.setProperty('background-color', 'rgba(0, 0, 0, 0.6)', 'important');
    modal.style.setProperty('background', 'rgba(0, 0, 0, 0.6)', 'important');
    // Use flex for perfect centering
    modal.style.display = 'flex';
    modal.classList.add('show');
    const setBackground = () => {
      if (modal) {
        modal.style.setProperty('background-color', 'rgba(0, 0, 0, 0.6)', 'important');
        modal.style.setProperty('background', 'rgba(0, 0, 0, 0.6)', 'important');
      }
    };
    setBackground();
    requestAnimationFrame(() => {
      setBackground();
      setTimeout(setBackground, 0);
      setTimeout(setBackground, 10);
      setTimeout(setBackground, 50);
      setTimeout(setBackground, 100);
    });
    document.body.classList.add('modal-open');
    document.documentElement.classList.add('modal-open');
    const observer = new MutationObserver(() => {
      if (modal && modal.style.display !== 'none') setBackground();
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });
    modal._backgroundObserver = observer;
  }
};

export const closeEventModal = () => {
  const modal = document.getElementById('event-modal');
  if (modal) {
    if (modal._backgroundObserver) {
      modal._backgroundObserver.disconnect();
      delete modal._backgroundObserver;
    }
    const scrollPos = modal.dataset.scrollY != null ? modal.dataset.scrollY : '0';
    modal.style.display = 'none';
    modal.classList.remove('show');
    modal.style.backgroundColor = '';
    modal.style.background = '';
    document.body.classList.remove('modal-open');
    document.documentElement.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    preventFocusScroll();
    restoreScroll(scrollPos);
  }
};

// Close modals when clicking outside
if (typeof window !== 'undefined') {
  window.addEventListener('click', (event) => {
    const modals = ['demo-booking-modal', 'elite-buyer-modal', 'service-interest-modal', 'event-modal'];
    modals.forEach(modalId => {
      const modal = document.getElementById(modalId);
      if (modal && event.target === modal) {
        if (modalId === 'demo-booking-modal') closeDemoBookingModal();
        else if (modalId === 'elite-buyer-modal') closeEliteBuyerModal();
        else if (modalId === 'service-interest-modal') closeServiceInterestModal();
        else if (modalId === 'event-modal') closeEventModal();
      }
    });
  });
}

